/**
 * Apply ?view=prepared&wiserId=&workDate=&focusPreparedDrop= from the URL.
 */

import { useCallback, useEffect, useMemo, type Dispatch, type SetStateAction } from 'react';

import type { PreparedSubTab } from '../types';

function parseWiserId(s: string | null): number | null {
  if (s == null || s === '') return null;
  const n = Number(s);
  return Number.isFinite(n) && n >= 1 ? Math.trunc(n) : null;
}

export function useSmswiserPreparedDeepLink(opts: {
  searchParams: URLSearchParams;
  setSearchParams: (
    updater: (prev: URLSearchParams) => URLSearchParams,
    navOpts?: { replace?: boolean },
  ) => void;
  setPreparedCampaignId: Dispatch<SetStateAction<number | null>>;
  setWorkDate: Dispatch<SetStateAction<string>>;
  setPreparedSubTab: Dispatch<SetStateAction<PreparedSubTab>>;
}) {
  const {
    searchParams,
    setSearchParams,
    setPreparedCampaignId,
    setWorkDate,
    setPreparedSubTab,
  } = opts;

  const highlightPreparedDropId = useMemo(() => {
    const v = searchParams.get('focusPreparedDrop');
    return v != null && v.length > 0 ? v : null;
  }, [searchParams]);

  const wiserKey = searchParams.get('wiserId');
  const workDateKey = searchParams.get('workDate');
  const preparedSubKey = searchParams.get('preparedSubTab');

  useEffect(() => {
    const w = parseWiserId(wiserKey);
    if (w != null) setPreparedCampaignId(w);
  }, [wiserKey, setPreparedCampaignId]);

  useEffect(() => {
    const d = workDateKey;
    if (d != null && /^\d{4}-\d{2}-\d{2}$/.test(d)) setWorkDate(d);
  }, [workDateKey, setWorkDate]);

  useEffect(() => {
    if (preparedSubKey === 'sent') setPreparedSubTab('sent');
  }, [preparedSubKey, setPreparedSubTab]);

  const clearFocusPreparedDropParam = useCallback(() => {
    setSearchParams(
      (prev) => {
        const next = new URLSearchParams(prev);
        next.delete('focusPreparedDrop');
        return next;
      },
      { replace: true },
    );
  }, [setSearchParams]);

  return { highlightPreparedDropId, clearFocusPreparedDropParam };
}
